import { useMutation, useQueryClient } from '@tanstack/react-query';
import { commentsApi, type CommentScope } from '../api/commentsApi';

interface UseDeleteCommentOptions {
  scope?: CommentScope;
  onSuccess?: (data: unknown, commentId: string) => void;
  onError?: (error: Error) => void;
}

export const useDeleteComment = (issueKey: string, options: UseDeleteCommentOptions = {}) => {
  const queryClient = useQueryClient();
  const { scope = 'user', onSuccess: onSuccessCallback, onError: onErrorCallback } = options;

  return useMutation({
    mutationFn: (commentId: string) => commentsApi.deleteComment(issueKey, commentId, scope),
    onSuccess: (data, commentId) => {
      queryClient.invalidateQueries({ queryKey: ['comments', issueKey] });
      if (onSuccessCallback) {
        onSuccessCallback(data, commentId);
      }
    },
    onError: (error: Error) => {
      console.error('Error deleting comment:', error);
      if (onErrorCallback) {
        onErrorCallback(error);
      }
    },
  });
};
